import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/address'

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })

  return response?.data
}
